import { Box, FlexLayout } from '@deity/falcon-ui';
import { TabItem, Tabs } from 'components';
import type { EntityTab } from 'contracts/interfaces';
import type { FC } from 'react';

type EntityDetailsWrapperProps = {
  tabs: EntityTab[];
  maxWidth?: number;
  onChange?: (tab: string) => boolean | undefined | void;
};
export const EntityDetailsWrapper: FC<EntityDetailsWrapperProps> = ({ tabs, maxWidth, onChange }) => (
  <FlexLayout justifyContent="center" width="full">
    <Box width="full" style={{ transform: 'translateY(-2.1em)', height: '100%', maxWidth: '1200px' }}>
      <Tabs maxWidth={maxWidth} onChange={onChange}>
        {tabs?.map(tab => (
          <TabItem label={tab.label} key={tab.label} isActive={tab.isActive ?? false} keepAlive={tab.keepAlive}>
            {tab.content}
          </TabItem>
        ))}
      </Tabs>
    </Box>
  </FlexLayout>
);
